/**
 * Parse / serialize do campo ura.condicoes (legado Xpro).
 * Formato: variavel:x,operadores:igual,valor:y[,andor:and|or],...
 */

export function parseCondicoesString(str) {
  if (!str) return [];
  const arrCond = String(str)
    .toLowerCase()
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  const variaveis = [];
  const operadores = [];
  const valores = [];
  const andor = [];
  arrCond.forEach((c) => {
    const colon = c.indexOf(":");
    if (colon < 0) return;
    const k = c.slice(0, colon);
    const v = c.slice(colon + 1);
    if (k === "variavel") variaveis.push(v || "");
    else if (k === "operadores") operadores.push(v || "");
    else if (k === "valor") valores.push(v || "");
    else if (k === "andor") andor.push(v || "");
  });
  const items = [];
  const max = Math.max(variaveis.length, operadores.length, valores.length);
  for (let i = 0; i < max; i += 1) {
    items.push({
      variavel: variaveis[i] || "",
      operador: operadores[i] || "igual",
      valor: valores[i] || "",
      andOr: andor[i] || (i === 0 ? "" : "and"),
    });
  }
  return items;
}

export function buildCondicoesString(items) {
  const parts = [];
  (items || []).forEach((item, idx) => {
    const v = (item.variavel || "").trim();
    const op = item.operador || "";
    const val = String(item.valor ?? "").trim();
    const andOr = item.andOr || (idx === 0 ? "" : "and");
    if (!v || !op) return;
    parts.push(`variavel:${v}`, `operadores:${op}`, `valor:${val}`);
    if (andOr) parts.push(`andor:${andOr}`);
  });
  return parts.join(",");
}
